"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLightClientScript = exports.toFetchTransactionResult = exports.toFetchHeaderResult = void 0;
var _type = require("./type");
var _rpc = require("@ckb-lumos/rpc");
/* eslint-disable camelcase, @typescript-eslint/no-explicit-any */

const toFetchHeaderResult = result => {
  if (!result) return result;
  if (result.status === _type.FetchFlag.Fetched) {
    return {
      status: result.status,
      data: _rpc.ResultFormatter.toHeader(result.data)
    };
  }
  return result;
};
exports.toFetchHeaderResult = toFetchHeaderResult;
const toFetchTransactionResult = result => {
  if (!result) return result;
  if (result.status === _type.FetchFlag.Fetched) {
    return {
      status: result.status,
      data: _rpc.ResultFormatter.toTransactionWithStatus(result.data)
    };
  }
  return result;
};
exports.toFetchTransactionResult = toFetchTransactionResult;
const toLightClientScript = lightClientScript => {
  if (!lightClientScript) return lightClientScript;
  return {
    script: _rpc.ResultFormatter.toScript(lightClientScript.script),
    blockNumber: lightClientScript.block_number,
    scriptType: lightClientScript.script_type
  };
};
exports.toLightClientScript = toLightClientScript;
//# sourceMappingURL=resultFormatter.js.map